export const FlowerOpenIcon = () => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.35291 2.24309L9.74967 0.733324L7.81777 0.155733C6.44679 -0.254156 4.97126 0.159059 3.98005 1.23047L2.60365 2.71824L1.17732 4.15964C0.152188 5.19559 -0.243177 6.73773 0.149006 8.1706L0.701647 10.1897L2.1462 8.72991C3.17133 7.69395 3.5667 6.15181 3.17451 4.71894L2.63735 2.7564L4.5152 3.31783C5.88618 3.72771 7.3617 3.3145 8.35291 2.24309Z'
        fill='#838383'
      />
      <path
        d='M12.8789 9.42537V8.4165C12.8789 8.95457 13.3079 9.31327 13.5224 9.42537H12.8789Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.1909 4.04541C4.0132 4.04541 3.86914 4.19597 3.86914 4.3817V9.04788C3.86914 10.0949 4.25853 11.101 4.95508 11.8536L4.99082 11.8922C5.90525 12.8802 7.21106 13.3612 8.51613 13.1907L8.81017 13.1523C9.03146 13.2525 9.24766 13.6066 9.33911 13.7978L11.4349 11.88L13.522 9.42603L12.8785 9.08974L12.8877 9.01282C13.08 7.40516 12.4058 5.81819 11.1358 4.88909L10.9797 4.77489C10.3307 4.30009 9.55771 4.04541 8.76551 4.04541H4.1909Z'
        fill='white'
      />
      <path
        d='M13.5232 9.42516C13.9651 9.88702 13.407 11.228 12.2362 12.4518C11.0653 13.6755 9.78205 14.2586 9.34014 13.7968C9.01854 13.1247 9.61736 12.1622 10.7882 10.9385C11.9591 9.71473 13.0406 9.08887 13.5232 9.42516Z'
        fill='white'
      />
      <path
        d='M13.1298 9.69615C13.4685 10.0501 12.9585 11.1571 11.9907 12.1686C11.0228 13.1801 9.96367 13.7132 9.62498 13.3592C9.28628 13.0052 9.7963 11.8983 10.7641 10.8867C11.732 9.87521 12.7911 9.34217 13.1298 9.69615Z'
        fill='#838383'
      />
    </svg>
  );
};
